const LIVEBRIDGE_ROOM_ID = "main-stage";

async function readJson(response) {
  let payload = null;

  try {
    payload = await response.json();
  } catch (error) {
    payload = null;
  }

  if (!response.ok) {
    throw new Error(payload?.error || "LiveBridge request failed.");
  }

  return payload;
}

export async function sendLiveBridgeMessage({
  sender,
  englishText,
  chineseText,
  roomId = LIVEBRIDGE_ROOM_ID
}) {
  const response = await fetch("/api/livebridge/messages", {
    method: "POST",
    headers: {
      "Content-Type": "application/json; charset=utf-8"
    },
    body: JSON.stringify({
      roomId,
      sender,
      englishText,
      chineseText
    })
  });

  return readJson(response);
}

export async function updateLiveBridgePreview({
  sender,
  englishText,
  chineseText,
  roomId = LIVEBRIDGE_ROOM_ID
}) {
  const response = await fetch("/api/livebridge/messages", {
    method: "POST",
    headers: {
      "Content-Type": "application/json; charset=utf-8"
    },
    body: JSON.stringify({
      roomId,
      action: "updatePreview",
      sender,
      englishText,
      chineseText
    })
  });

  return readJson(response);
}

export async function resetLiveBridgeSession({ roomId = LIVEBRIDGE_ROOM_ID }) {
  const response = await fetch("/api/livebridge/messages", {
    method: "POST",
    headers: {
      "Content-Type": "application/json; charset=utf-8"
    },
    body: JSON.stringify({
      roomId,
      action: "resetSession"
    })
  });

  return readJson(response);
}

export async function fetchLiveBridgeMessages({
  password,
  roomId = LIVEBRIDGE_ROOM_ID
}) {
  const response = await fetch(
    `/api/livebridge/messages?room=${encodeURIComponent(roomId)}`,
    {
      headers: {
        "x-livebridge-password": password
      }
    }
  );

  return readJson(response);
}

export async function translateLiveBridgeText({
  text,
  sourceLanguage = "en",
  targetLanguage = "zh"
}) {
  const response = await fetch("/api/livebridge/translate", {
    method: "POST",
    headers: {
      "Content-Type": "application/json; charset=utf-8"
    },
    body: JSON.stringify({
      text,
      sourceLanguage,
      targetLanguage
    })
  });

  return readJson(response);
}

export async function organizeLiveBridgeContent({
  text,
  sourceLanguage = "en-US",
  targetLanguage = "zh-CN"
}) {
  const response = await fetch("/api/organize", {
    method: "POST",
    headers: {
      "Content-Type": "application/json; charset=utf-8"
    },
    body: JSON.stringify({
      text,
      sourceLanguage,
      targetLanguage
    })
  });

  return readJson(response);
}

export async function transcribeLiveBridgeAudio({
  audioBlob,
  sourceLanguage = "en-US",
  previewText = ""
}) {
  const formData = new FormData();
  formData.append("audio", audioBlob, "livebridge-audio.webm");
  formData.append("sourceLanguage", sourceLanguage);
  formData.append("previewText", previewText);

  const response = await fetch("/api/transcribe", {
    method: "POST",
    body: formData
  });

  return readJson(response);
}

export { LIVEBRIDGE_ROOM_ID };
